export class HighlightManager {
  private element: HTMLElement;

  constructor(panelElement: HTMLElement) {
    this.element = panelElement;
  }

  highlightElement(selector: string, highlight: boolean): void {
    try {
      const elements = document.querySelectorAll(selector);

      elements.forEach((element) => {
        const existingOverlay = element.querySelector('.ce-highlight-overlay');
        if (existingOverlay) {
          existingOverlay.remove();
        }

        if (highlight) {
          const overlay = document.createElement('div');
          overlay.className = 'ce-highlight-overlay';
          overlay.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            outline: 2px solid #3b82f6;
            outline-offset: 2px;
            background-color: rgba(59, 130, 246, 0.1);
            pointer-events: none;
            z-index: 999;
            transition: all 0.2s ease;
          `;

          const computedStyle = window.getComputedStyle(element);
          if (computedStyle.position === 'static') {
            (element as HTMLElement).style.position = 'relative';
          }

          element.appendChild(overlay);
        }
      });
    } catch (error) {
      console.warn('Invalid selector for highlighting:', selector);
    }
  }

  clearHighlights(): void {
    const overlays = document.querySelectorAll('.ce-highlight-overlay');
    overlays.forEach((overlay) => overlay.remove());
  }

  setupModificationHoverHighlights(modifications: any[]): void {
    const listElement = this.element.querySelector('[data-ce="list"]');
    if (!listElement) return;

    listElement.querySelectorAll('[data-ce-mod-item]').forEach((item, index) => {
      const mod = modifications[index];

      item.addEventListener('mouseenter', () => {
        this.highlightElement(mod.selector, true);
      });

      item.addEventListener('mouseleave', () => {
        this.highlightElement(mod.selector, false);
      });
    });
  }
}
